import { defaultFieldResolver } from "graphql";
export default defaultFieldResolver;
